import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'directories.filters-v2.main.content.error.header',
		defaultMessage: "We couldn't load your filters",
		description:
			'Heading for the error state (error screen) which is displayed for users on filters page in case filters fetching ended up with an error',
	},
	description: {
		id: 'directories.filters-v2.main.content.error.description',
		defaultMessage:
			'Give it another try. If you run into more trouble, contact your admin for help.',
		description:
			'Message for the error state (error screen) which is displayed for users on filters page in case filters fetching ended up with an error',
	},
});
export default messages;
